import { LegalPage } from './LegalPage'
import { privacyHtml } from './privacyContent'

export const PrivacyPage = () => <LegalPage html={privacyHtml} />

export default PrivacyPage
